import { API_BASE, API_URL, APPLICATION_JSON_HEADER } from "@/constants";
import { getApiError } from "@/utils/api-error";

import { CartItemModel, CartModel } from "./types";

export type CartApiPostRequestBody = {
  products: CartItemModel[];
  dispensers: CartItemModel[];
};

export type CartApiResponseBody = CartModel;

export async function postCart(body: CartApiPostRequestBody) {
  const response = await fetch(`${API_URL}${API_BASE}/cart`, {
    method: "POST",
    headers: {
      ...APPLICATION_JSON_HEADER,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw await getApiError(response);
  }
  return response.json() as Promise<CartApiResponseBody>;
}

export async function getCart() {
  const response = await fetch(`${API_URL}${API_BASE}/cart`);

  if (!response.ok) {
    throw await getApiError(response);
  }

  return response.json() as Promise<CartApiResponseBody>;
}
